//////LIBRARY//////
import React, { useEffect, useState } from 'react'
import { bindActionCreators } from 'redux'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { isUndefined, find } from 'lodash'
import styled from 'styled-components'
//////COMPONENTS//////
import theme from '../../../../theme/theme'
import { useHistory } from 'react-router-dom'
import { itemCatalogActionCreators } from '../../../../store/actions'
import userPrivileges from '../../../../constants/PrivilegesList'
import { uriList } from '../../../../routings/settings/RouteList'
import convertHexToRGBA from '../../../../helpers/HexToRgba'

//////STYLED//////
const Wrapper = styled.div`
	display: flex;
	flex: 4;
	column-gap: 1rem;
	font-size: 14px;
`
const StockBlock = styled.div`
	text-align: center;
	flex: 2;
`
const Stock = styled.span`
	background-color: ${(props) => convertHexToRGBA(props?.color, 0.2)};
	color: ${(props) => props?.color};
	line-height: 25px;
	font-weight: bold;
	width: fit-content;
	border-radius: 15px;
	margin: 0 auto;
	padding: 7px 10px;
	bottom: 0;
`
const PromoBlock = styled.div`
	text-align: center;
	background-color: ${(props) => props.type == 'promo' && convertHexToRGBA(theme.colors.card.promoColor, 0.2)};
	font-weight: bold;
	width: fit-content;
	border-radius: 15px;
	color: ${theme.colors.card.promoColor};
	flex: 2;
`
const LinkBlock = styled.div`
	flex: 2;
	text-align: left;
	text-decoration: underline;
	color: ${(props) => props.theme.colors.primary};
	& span {
		cursor: pointer;
	}
`
//////STYLED//////

const ItemCatalogDetailBlock = ({ target, ItemDetail, translations }) => {
	const [color, setColor] = useState()
	const [message, setMessage] = useState()
	const { userRolePrivileges } = useSelector(
		(state) => ({
			userRolePrivileges: state.user.identity.rolePrivileges,
		}),
		shallowEqual
	)

	const actionsItemCatalogDetail = bindActionCreators(itemCatalogActionCreators, useDispatch())

	const history = useHistory()

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handleSeeSale = (row) => {
		// We pass item label to sales history manager search bar
		// But method might change
		actionsItemCatalogDetail.setSaleByArticle(row)
		history.push(`${uriList.sales}${uriList.salesByArticleHistory}`)
	}

	const handleSeeStocks = (row) => {
		actionsItemCatalogDetail.getStocksFiltersInfo(row)
		history.push(`${uriList.recapStock}`)
	}

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		if (parseInt(ItemDetail?.lockerStock, 10) > parseInt(ItemDetail?.stockAlert, 10)) {
			setColor(theme.colors.validation)
			setMessage(translations['page__itemCatalog__kiosk__sticker_inStock'])
		} else if (
			parseInt(ItemDetail?.lockerStock, 10) <= parseInt(ItemDetail?.stockAlert, 10) &&
			parseInt(ItemDetail?.lockerStock, 10) > parseInt(0, 10)
		) {
			setColor(theme.colors.warning)
			setMessage(translations['page__itemCatalog__kiosk__sticker_inStock'])
		} else {
			setColor(theme.colors.error)
			setMessage(translations['page__itemCatalog__kiosk__sticker_soldOut'])
		}
	}, [ItemDetail, translations])

	/////////////////////////////// RENDER //////////////////////////////////////

	return (
		<Wrapper>
			{target == 'stock' && (
				<>
					<StockBlock>
						<Stock color={color}>
							{message} {ItemDetail.lockerStock} / {ItemDetail.kioskCapacity}
						</Stock>
					</StockBlock>
					{!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[15])) && (
						<LinkBlock>
							<span onClick={() => handleSeeStocks(ItemDetail)}>{translations['page__itemCatalog__kiosk_detail__linkTo_stock']}</span>
						</LinkBlock>
					)}
				</>
			)}
			{target == 'promo' && (
				<>
					{ItemDetail?.promo ? (
						<PromoBlock type="promo" color={color}>
							<div>{translations['page__itemCatalog__kiosk__sticker_promo']}</div>
						</PromoBlock>
					) : (
						<PromoBlock>
							<div></div>
						</PromoBlock>
					)}
					{!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[10])) && (
						<LinkBlock>
							<span onClick={() => handleSeeSale(ItemDetail)}>{translations['page__itemCatalog__kiosk_detail__linkTo_sales']}</span>
						</LinkBlock>
					)}
				</>
			)}
		</Wrapper>
	)
}

export default ItemCatalogDetailBlock
